var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcWeth40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#ec1c79",
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.526 56.615c6.525 0 6.525-.1 7.632-.425 1.446-.429-4.085-4.256-7.632-4.256s-6.426 1.048-6.426 2.341 2.877 2.34 6.426 2.34z",
    transform: "translate(5.771 -23.901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.56 6.311.3.323-.262.354c-8.51 11.512-13.413 16.712-15.498 16.018-1.262-.426-2.532-1.706-3.8-3.564-.446-.654-.866-1.342-1.247-2.026-.254-.456-.469-.872-.581-1.106a2.756 2.756 0 0 1 -.25-.725l-.006-.029c-.02-.1-.027-.135-.042-.191a11.6 11.6 0 0 1 16.862-13.11l.044.028a28.584 28.584 0 0 1 4.48 4.027zm-5.067-3.139a10.541 10.541 0 0 0 -15.293 11.921c.023.087.034.136.058.261v.026a1.728 1.728 0 0 0 .167.473c.1.214.307.609.549 1.046.367.658.769 1.319 1.2 1.945 1.151 1.678 2.288 2.826 3.271 3.156 1.31.44 6.241-4.78 14.034-15.285a26.768 26.768 0 0 0 -3.987-3.543z",
    transform: "translate(6.554 6.499)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.054 4.734a10.541 10.541 0 0 0 -15.294 11.921c.023.087.034.136.058.261v.026a1.728 1.728 0 0 0 .165.471c.1.214.307.609.549 1.046.367.658.769 1.319 1.2 1.945 1.15 1.679 2.288 2.826 3.268 3.156 1.31.44 6.241-4.78 14.034-15.285a26.768 26.768 0 0 0 -3.983-3.541z",
    fill: "#ec1c79",
    transform: "translate(4.993 4.937)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.63 29.228a11.6 11.6 0 1 1 11.6-11.6 11.6 11.6 0 0 1 -11.6 11.6zm0-1.064a10.533 10.533 0 1 0 -10.53-10.534 10.533 10.533 0 0 0 10.53 10.534z",
    transform: "translate(3.433 3.381)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19.189 29.723a10.533 10.533 0 1 0 -10.533-10.534 10.533 10.533 0 0 0 10.533 10.534z",
    fill: "#fff",
    transform: "translate(1.874 1.821)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13.155 33.77-1.394-4.2h1.222l.727 2.413.8-2.425h.995l.8 2.425.727-2.413h1.2l-1.394 4.2h-1.002l-.84-2.4-.833 2.4zm5.544-.03v-4.17h3.355v.981h-2.213v.632h2v.912h-2v.661h2.24v.983zm4.993 0v-3.157h-1.254v-1.013h3.662v1.013h-1.255v3.157zm2.913 0v-4.17h1.154v1.561h1.484v-1.561h1.157v4.17h-1.157v-1.584h-1.484v1.584z",
    transform: "translate(.029 -10.602)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m2.009 24.84a.6.6 0 0 1 .535-1.065l1.7.851a.6.6 0 1 1 -.535 1.065z",
    transform: "translate(6.021 -7.127)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5 31.786a.6.6 0 1 1 .5-1.086l1.7.786a.6.6 0 0 1 -.5 1.081z",
    transform: "translate(6.334 -11.25)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWeth40);
export default __webpack_public_path__ + "static/media/ic_weth_40.334ca16a5ef5109a3a56365f20d388ab.svg";
export { ForwardRef as ReactComponent };